/**
 * Helpers for interpreting axios errors from the Planning Poker API.
 */

/** True when the request failed because the resource does not exist. */
export const isNotFoundError = (error: any): boolean =>
  error?.response?.status === 404 || error?.status === 404;

/** Human-readable message for an API error, falling back to a caller-supplied default. */
export const apiErrorMessage = (error: any, fallback: string): string =>
  error?.response?.data?.error || error?.message || fallback;
